import { render } from "./InfoBox.vue?vue&type=template&id=33d1a2f8&scoped=true"
import script from "./InfoBox.vue?vue&type=script&lang=js"
export * from "./InfoBox.vue?vue&type=script&lang=js"

import "./InfoBox.vue?vue&type=style&index=0&id=33d1a2f8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/range-compose-campaign-ui_master/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d1a2f8"]])

export default __exports__